module.exports = __webpack_public_path__ + "abd329f1a89c556f669641bb6839f6c0.png";